var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.442,
    height: 21.445,
    viewBox: "0 0 36.442 36.445",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8302",
    "data-name": "Group 8302",
    transform: "translate(16109.237 19317.217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16062",
    "data-name": "Path 16062",
    d: "M597.215,41.145A18.222,18.222,0,1,0,579,22.94a18.232,18.232,0,0,0,18.218,18.205",
    transform: "translate(-16688.234 -19321.918)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16063",
    "data-name": "Path 16063",
    d: "M597.215,41.144a18.222,18.222,0,1,1,18.224-18.2,18.232,18.232,0,0,1-18.224,18.2m10.712-8.958c0-1.184.016-2.315,0-3.446a57.63,57.63,0,0,0-.164-5.761c-.361-3.068-2.7-4.717-5.769-4.319a4.664,4.664,0,0,0-3.113,1.964c-.044-.667-.077-1.158-.111-1.678h-4.308V32.189h4.362c0-.827,0-1.605,0-2.384,0-1.762-.022-3.523.014-5.284a2.38,2.38,0,0,1,2.261-2.421c1.325-.07,2.145.682,2.332,2.165a10.012,10.012,0,0,1,.063,1.216c.006,1.951,0,3.9.005,5.854,0,.284.032.569.049.851Zm-16,.011c0-4.317,0-8.538,0-12.758,0-.439-.214-.55-.6-.545-1,.013-2.006.046-3-.011-.705-.04-.851.236-.847.886.026,3.871.012,7.742.014,11.614,0,.262.024.524.038.815ZM589.76,12.473a2.268,2.268,0,0,0-2.5,2.277,2.238,2.238,0,0,0,2.386,2.308,2.3,2.3,0,1,0,.117-4.586",
    transform: "translate(-16688.234 -19321.916)",
    fill: "#5aa2fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16064",
    "data-name": "Path 16064",
    d: "M633.2,54.909h-4.384c-.017-.282-.048-.566-.049-.851,0-1.951,0-3.9-.005-5.854a9.987,9.987,0,0,0-.063-1.216c-.187-1.482-1.007-2.234-2.332-2.165a2.38,2.38,0,0,0-2.261,2.421c-.035,1.761-.012,3.523-.014,5.285,0,.778,0,1.557,0,2.384h-4.362V41.669h4.308c.034.52.067,1.011.111,1.678a4.664,4.664,0,0,1,3.113-1.964c3.068-.4,5.408,1.25,5.769,4.319.224,1.9.132,3.839.164,5.761.019,1.131,0,2.262,0,3.446",
    transform: "translate(-16713.508 -19344.639)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16065",
    "data-name": "Path 16065",
    d: "M605.79,55.371h-4.4c-.014-.291-.038-.553-.038-.815,0-3.872.012-7.743-.015-11.614,0-.649.142-.926.847-.886,1,.057,2,.024,3,.011.391,0,.605.106.6.545-.007,4.22,0,8.441,0,12.758",
    transform: "translate(-16702.096 -19345.092)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16066",
    "data-name": "Path 16066",
    d: "M603.261,25.177a2.3,2.3,0,1,1-.117,4.586,2.238,2.238,0,0,1-2.386-2.308,2.268,2.268,0,0,1,2.5-2.277",
    transform: "translate(-16701.734 -19334.621)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/linkedIn.42f8915456c920dd12c502f616367e8e.svg";
export { ForwardRef as ReactComponent };